import React from 'react';
import Lottie from "lottie-react";
import LoaderAnimation from "../../assets/loader.json";

const Loader = ({fullPage = true}) => {
    return (
        <div className={`loader flex flex-align-center flex-justify-center ${fullPage ? 'full-page' : ''}`}>
            <Lottie animationData={LoaderAnimation} loop={true} />
        </div>
    );
}

export default Loader;
